import { render, staticRenderFns } from "./SystemSettingsIndex.vue?vue&type=template&id=15b22ae9&scoped=true"
import script from "./SystemSettingsIndex.vue?vue&type=script&lang=js"
export * from "./SystemSettingsIndex.vue?vue&type=script&lang=js"
import style0 from "./SystemSettingsIndex.vue?vue&type=style&index=0&id=15b22ae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b22ae9",
  null
  
)

export default component.exports